import React, { FunctionComponent, useState, useEffect } from 'react';
import { Image, Button } from '@mantine/core';
import { IconArrowRight, IconX } from '@tabler/icons-react';
import classNames from 'classnames';

import useMobile from 'src/shared/hooks/use-mobile';
import twAnnouncementModal from 'src/assets/images/tw/modal-announcement.png';

import styles from '../styles/tw-announcement-mobile-styles.module.scss';
import { TW_ANNOUNCEMENT_URL } from '../constants';

export const TwMobileBannerComponent: FunctionComponent = () => {
    const [visible, setVisible] = useState(true);
    const [isFixed, setIsFixed] = useState(false);
    const mobile = useMobile();

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;

            if (scrollPosition > windowHeight * 0.2) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!mobile || !visible) return null;

    return (
        <div className={classNames(styles.banner, { [styles.fixed]: isFixed })}>
            <IconX className={styles.bannerCloseIcon} size={'9vw'} stroke={1.5} onClick={() => setVisible(false)} />
            <div className={styles.bannerContent}>
                <Image
                    className={styles.bannerImg}
                    onClick={() => window.open(TW_ANNOUNCEMENT_URL, '_blank')}
                    src={twAnnouncementModal}
                />
                <Button
                    onClick={() => window.open(TW_ANNOUNCEMENT_URL, '_blank')}
                    variant="unstyled"
                    rightSection={<IconArrowRight />}
                    styles={{ section: { margin: 0 }, label: { marginLeft: -12, marginRight: 6 } }}
                    className={styles.learnMoreButton}
                    size="xl"
                    radius="lg"
                >
                    Learn more
                </Button>
            </div>
        </div>
    );
};
